module.exports = __webpack_public_path__ + "img/item-2.3c28306.png";